// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Buses$XodProject = require("./Buses.bs.js");

function linkifyPatchRecursivelyU(patchPath, project) {
  return Buses$XodProject.linkifyPatchRecursively(project, patchPath);
}

function splitLinksToBusesU(getBusPosition, patchPath, linkIds, project) {
  return Buses$XodProject.splitLinksToBuses(getBusPosition, patchPath, Belt_List.fromArray(linkIds), project);
}

exports.linkifyPatchRecursivelyU = linkifyPatchRecursivelyU;
exports.splitLinksToBusesU = splitLinksToBusesU;
/* Buses-XodProject Not a pure module */
